var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#6A8860"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#6A8860"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 30.32C14.3092 30.32 9.67969 25.6905 9.67969 20C9.67969 14.3095 14.3092 9.67999 19.9997 9.67999C25.6902 9.67999 30.3197 14.3095 30.3197 20C30.3197 25.6905 25.6902 30.32 19.9997 30.32ZM19.9997 11.512C15.3194 11.512 11.5117 15.3197 11.5117 20C11.5117 24.6802 15.3206 28.488 19.9997 28.488C24.6787 28.488 28.4877 24.6802 28.4877 20C28.4877 15.3197 24.6799 11.512 19.9997 11.512Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0009 21.2538C20.7598 21.2538 21.3749 20.6387 21.3749 19.8798C21.3749 19.121 20.7598 18.5059 20.0009 18.5059C19.2421 18.5059 18.627 19.121 18.627 19.8798C18.627 20.6387 19.2421 21.2538 20.0009 21.2538Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2636 21.2538C25.0225 21.2538 25.6376 20.6387 25.6376 19.8798C25.6376 19.121 25.0225 18.5059 24.2636 18.5059C23.5048 18.5059 22.8896 19.121 22.8896 19.8798C22.8896 20.6387 23.5048 21.2538 24.2636 21.2538Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7373 21.2538C16.4961 21.2538 17.1113 20.6387 17.1113 19.8798C17.1113 19.121 16.4961 18.5059 15.7373 18.5059C14.9784 18.5059 14.3633 19.121 14.3633 19.8798C14.3633 20.6387 14.9784 21.2538 15.7373 21.2538Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0009 21.2538C20.7598 21.2538 21.3749 20.6387 21.3749 19.8798C21.3749 19.121 20.7598 18.5059 20.0009 18.5059C19.2421 18.5059 18.627 19.121 18.627 19.8798C18.627 20.6387 19.2421 21.2538 20.0009 21.2538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllActive);
export default __webpack_public_path__ + "static/media/allActive.a1b6460001e004c3e2bb89518119d82d.svg";
export { ForwardRef as ReactComponent };